import { useMemo } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

import {
  setConfigTableFilters,
  setColumnVisibility,
  setClearConfigTableFilters,
} from '@Modal/reducers/providers/table/configsTableSlice';

// Types
import { StoreInterface } from 'src/app/types';
import { FilterItemType } from '@Modal/reducers/types';

export const useConfigsTable = () => {
  const dispatch = useDispatch();

  const { selectedFilters, columnVisibility, configTableFilters, columnVisibilityOptions } =
    useSelector((state: StoreInterface) => state?.configsTable);

  const configsListFilters = useMemo(() => {
    const columnVisibilityStrArr = Array.from(Object.values(columnVisibility)).map((filt) => filt);
    return columnVisibilityStrArr as string[];
  }, [columnVisibility]);

  const handleApplyColumnVisibility = (column: string[]) => {
    const newVisibleColumns = [...configsListFilters, ...column];
    if (configsListFilters.filter((col) => column.includes(col)).length > 0) {
      const filteredNewVisibleColumns = configsListFilters.filter((col) => col !== column[0]);
      dispatch(setColumnVisibility(filteredNewVisibleColumns));
    } else {
      dispatch(setColumnVisibility(newVisibleColumns));
    }
  };

  const handleFilterSelect = (filter: FilterItemType) => {
    dispatch(setConfigTableFilters(filter));
  };

  const visiblityCustomizable = useMemo(
    () => ({
      value: columnVisibility,
      options: columnVisibilityOptions,
      apply: (value: string[]) => handleApplyColumnVisibility(value),
    }),
    [columnVisibility, columnVisibilityOptions]
  );

  const clearConfigTableFiltersHandler = () => {
    dispatch(setClearConfigTableFilters());
  };

  return {
    // State
    selectedFilters,
    columnVisibility,
    configsListFilters,
    configTableFilters,
    visiblityCustomizable,
    columnVisibilityOptions,
    // Actions
    setColumnVisibility,
    setConfigTableFilters,
    setClearConfigTableFilters,
    // Handlers
    handleFilterSelect,
    handleApplyColumnVisibility,
    clearConfigTableFiltersHandler,
  };
};
